.group {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.card {
  all: unset;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  box-sizing: border-box;
  width: 100%;
  padding: 1.6rem;
  border: 1px solid var(--color-grayscale-trout);
  border-radius: 0.4rem;
  background: transparent;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: var(--color-secondary);
  }

  &:focus-visible {
    outline: 2px solid var(--color-secondary);
    outline-offset: 2px;
  }

  &[data-state='checked'] {
    border-color: var(--color-secondary);
    background: var(--color-grayscale-arsenic);
  }

  &[data-disabled] {
    cursor: default;
    pointer-events: none;

    .title,
    .description {
      color: var(--color-grayscale-light-slate);
    }
  }
}

.title {
  display: flex;
  gap: 0.4rem;
  align-items: center;
  font-size: 1.4rem;
  font-weight: 400;
  color: var(--color-grayscale-white);
}

.description {
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 2rem;
  color: var(--color-grayscale-light-slate);
}
